import moment from 'moment'
moment.locale('es')

export function formatDate(date: string | Date) {
  return moment(date).format('D [de] MMMM, YYYY')
}
